/* Mercahome — scroll reveal + count-up. Reduced-motion safe. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function revealAll() {
    document.querySelectorAll('[data-reveal], [data-reveal-stagger]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
  }

  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    if (reduce) { el.textContent = target.toLocaleString('es-ES'); return; }
    var start = null, dur = 1400;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var val = Math.floor(p * target);
      el.textContent = val.toLocaleString('es-ES');
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = target.toLocaleString('es-ES');
    }
    requestAnimationFrame(step);
  }

  function init() {
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
      document.querySelectorAll('[data-count]').forEach(countUp);
      return;
    }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-revealed');
        e.target.querySelectorAll && e.target.querySelectorAll('[data-count]').forEach(countUp);
        if (e.target.hasAttribute('data-count')) countUp(e.target);
        obs.unobserve(e.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-reveal], [data-reveal-stagger], [data-count]').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
